import React, { memo, useEffect, useMemo, useState } from 'react'
import {
  OFFER_TYPE_CRUISE,
} from 'constants/offer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import LayoutContainer from 'components/Common/LayoutContainer'
import { buildSearchStringFromFilters } from 'lib/searchUtils'

import Heading from 'components/Luxkit/Typography/Heading'
import { useOfferList } from 'hooks/Offers/useOfferList'
import { take, without } from 'lib/arrayUtils'
import useOffers from 'hooks/Offers/useOffers'
import { EmptyObject } from 'lib/objectUtils'
import CruiseYouMayAlsoLikeTile from 'components/OfferPage/Cruises/YouMayAlsoLike/CruiseYouMayAlsoLikeTile'
import { useAppSelector } from 'hooks/reduxHooks'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import Group from 'components/utils/Group'

const emptyFilters: App.OfferListFilters = EmptyObject

interface Props {
  title?: string;
  id?: string;
  filters?: App.OfferListFilters;
  offerId?: string;
}

const MINIMUM_OFFERS_TO_DISPLAY = 3
export const RECOMMENDATION_TYPES: App.OfferType[] = [
  OFFER_TYPE_CRUISE,
]

function CruiseRecommendations(props: Props) {
  const {
    id,
    filters = emptyFilters,
    offerId,
  } = props

  const [offersToDisplay, setOffersToDisplay] = useState<App.CruiseOffer[]>([])

  const [offerList] = useOfferList({ ...filters, offerTypes: RECOMMENDATION_TYPES })

  const offerIds = useMemo(() => {
    const offerCandidates = offerList.offerIds.filter(id => id !== ('cruise:' + offerId))
    return take(without(offerCandidates, id ?? ''), 9)
  }, [id, offerList.offerIds, offerId])
  const [offersFetching] = useOffers(offerIds)
  const allOffers = useAppSelector(state => state.offer.offers)
  const offers = useMemo(():App.CruiseOffer[] =>
    offerIds.map<any>(id => allOffers[id.replace('cruise:', '')] || allOffers[id]).filter(Boolean)
  , [offerIds, allOffers])

  useEffect(() => {
    if (offersFetching) {
      setOffersToDisplay([])
    }
    setOffersToDisplay(offers)
  }, [offersFetching, offers])

  if (offersToDisplay.length < MINIMUM_OFFERS_TO_DISPLAY) {
    return null
  }
  return (
    <Pane>
      <PaneBody size="xl-y">
        <LayoutContainer>
          <Group direction="vertical" gap={16}>
            <Heading variant="heading3">Similar to this cruise</Heading>
            <CardCarousel pageSize={3}>
              {offersToDisplay.map((offer) => (
                <CruiseYouMayAlsoLikeTile
                  key={offer.id}
                  offer={offer}
                  linkQuery={buildSearchStringFromFilters(filters)}/>
              ))}
            </CardCarousel>
          </Group>
        </LayoutContainer>
      </PaneBody>
    </Pane>
  )
}

export default memo(CruiseRecommendations)
